import { createElement, useEffect, useState } from "react";
import './index.scss';
import classNames from "classnames";
const ColorfulTable = function ColorfulTable({ columns, data, hasBorder, size, isDelete, isOperition, isRowSelection, totalElements, pageSize, currentPage, onRowSelection, onRowDelete, onRowSave, ...otherProps }) {
    const prefixCls = 'au-table';
    const classNameList = classNames(prefixCls, {
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-border`]: hasBorder,
    });
    const [editingRowIndex, setEditingRowIndex] = useState(-1);
    const _otherProps = otherProps || {};
    const [tableCurrentPage, setTableCurrentPage] = useState(currentPage || 1);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [inputs, setInputs] = useState([]);
    const handleEdit = (rowData, rowIndex) => {
        setEditingRowIndex(rowIndex);
        const rowVals = Object.values(rowData)?.slice(1);
        if (rowVals) {
            setInputs(Object.values(rowVals));
        }
    };
    const handleSave = (rowData) => {
        setEditingRowIndex(-1);
        if (onRowSave) {
            onRowSave(inputs);
        }
    };
    const handleInputChange = (index, event) => {
        const values = [...inputs];
        values[index] = event.target.value;
        setInputs(values);
    };
    const handleDelete = (rowData) => {
        if (onRowDelete) {
            onRowDelete(rowData);
        }
    };
    const handlePageChange = (newPage) => {
        setTableCurrentPage(newPage);
    };
    const handleRowSelect = (rowIndex) => {
        const oldLen = selectedRows?.length;
        let nowSelectedRows = [];
        if (selectedRows?.includes(rowIndex)) {
            nowSelectedRows = selectedRows?.filter((index) => index !== rowIndex);
            setSelectedRows(nowSelectedRows);
            setIsAllSelected((oldLen - 1) === data.length);
        }
        else {
            nowSelectedRows = [...selectedRows, rowIndex];
            setSelectedRows(nowSelectedRows);
            setIsAllSelected((oldLen + 1) === data.length);
        }
        if (onRowSelection) {
            onRowSelection(nowSelectedRows);
        }
    };
    const handleAllSelect = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        }
        else {
            setSelectedRows(data?.map((_, index) => index));
        }
        setIsAllSelected(!isAllSelected);
        if (onRowSelection) {
            onRowSelection(isAllSelected ? [] : data);
        }
    };
    const isEmptyData = () => {
        if (data?.length > 0) {
            return false;
        }
        return true;
    };
    const isEmptyCol = () => {
        if (columns?.length > 0) {
            return false;
        }
        return true;
    };
    useEffect(() => {
    }, []);
    const getRowWrapper = (rowData, rowIndex) => {
        return (createElement("tr", null,
            isRowSelection && (createElement("td", null,
                createElement("span", { className: selectedRows?.includes(rowIndex) ? "au-table-checkbox au-table-checkbox-checked" : "au-table-checkbox" },
                    createElement("input", { type: "checkbox", name: "table-checkbox", className: "au-table-checkbox-input", onClick: () => handleRowSelect(rowIndex) }),
                    createElement("span", { className: "au-table-checkbox-inner" })))),
            columns?.map((column, innerRowIndex) => (createElement("td", { key: innerRowIndex }, rowIndex === editingRowIndex ? (createElement("input", { defaultValue: rowData[column?.dataIndex], onChange: (event) => handleInputChange(innerRowIndex, event) })) : (rowData[column?.dataIndex])))),
            (isOperition || isDelete) &&
                createElement("td", { className: "au-table-oper" },
                    isOperition && (rowIndex === editingRowIndex ?
                        createElement("button", { onClick: () => handleSave(rowData) }, "\u4FDD\u5B58") :
                        createElement("button", { onClick: () => handleEdit(rowData, rowIndex) }, "\u7F16\u8F91")),
                    isDelete && createElement("button", { onClick: () => handleDelete(rowData) }, "\u5220\u9664"))));
    };
    return (createElement("div", { className: classNameList, ..._otherProps },
        createElement("div", { className: 'au-table-content' },
            createElement("div", { className: 'au-table-scroll' },
                createElement("table", null,
                    createElement("thead", null,
                        createElement("tr", null,
                            isRowSelection && (createElement("th", { className: "au-table-all-check" },
                                createElement("span", { className: isAllSelected ? "au-table-checkbox-checked au-table-checkbox" : "au-table-checkbox" },
                                    createElement("input", { type: "checkbox", name: "table-checkbox", className: "au-table-checkbox-input", onClick: handleAllSelect }),
                                    createElement("span", { className: "au-table-checkbox-inner" })))),
                            columns?.map((column, colIndex) => (createElement("th", { key: colIndex, width: column?.width ? `${column.width}px` : 'auto' }, column?.title))),
                            isOperition && createElement("th", { className: "au-header-oper" }, "\u64CD\u4F5C"),
                            isEmptyCol() && (createElement("th", { className: "au-empty-th" }, "\u8868\u5934")))),
                    createElement("tbody", null,
                        data?.map(getRowWrapper),
                        isEmptyData() && (createElement("div", { className: "au-table-empty" }, "\u6682\u65E0\u6570\u636E"))))),
            isRowSelection &&
                createElement("div", { className: 'au-table-fixed-left' },
                    createElement("table", null,
                        createElement("thead", null,
                            createElement("tr", null,
                                createElement("th", { className: "au-table-all-check" },
                                    createElement("span", { className: isAllSelected ? "au-table-checkbox-checked au-table-checkbox" : "au-table-checkbox" },
                                        createElement("input", { type: "checkbox", name: "table-checkbox", className: "au-table-checkbox-input", onClick: handleAllSelect }),
                                        createElement("span", { className: "au-table-checkbox-inner" }))))),
                        createElement("tbody", null, data?.map((rowData, rowIndex) => (createElement("tr", { key: rowIndex },
                            createElement("td", null,
                                createElement("span", { className: selectedRows?.includes(rowIndex) ? "au-table-checkbox-checked au-table-checkbox" : "au-table-checkbox" },
                                    createElement("input", { type: "checkbox", name: "table-checkbox", className: "au-table-checkbox-input", onClick: () => handleRowSelect(rowIndex) }),
                                    createElement("span", { className: "au-table-checkbox-inner" }))))))))),
            (isOperition || isDelete) &&
                createElement("div", { className: 'au-table-fixed-right' },
                    createElement("table", null,
                        createElement("thead", null,
                            createElement("tr", null,
                                createElement("th", { className: "au-header-oper" }, "\u64CD\u4F5C"))),
                        createElement("tbody", null, data?.map((rowData, rowIndex) => (createElement("tr", { key: rowIndex },
                            createElement("td", { className: "au-table-oper" },
                                isOperition && (rowIndex === editingRowIndex ?
                                    createElement("button", { onClick: () => handleSave(rowData) }, "\u4FDD\u5B58") :
                                    createElement("button", { onClick: () => handleEdit(rowData, rowIndex) }, "\u7F16\u8F91")),
                                isDelete && createElement("button", { onClick: () => handleDelete(rowData) }, "\u5220\u9664"))))))))),
        totalElements > 0 && (createElement("div", { className: "au-table-page" },
            createElement("button", { disabled: tableCurrentPage === 1, onClick: () => handlePageChange(tableCurrentPage - 1) },
                createElement("i", { className: "icon-angle-left" })),
            createElement("span", { className: "au-table-now" }, tableCurrentPage),
            createElement("button", { disabled: tableCurrentPage === totalElements / pageSize, onClick: () => handlePageChange(tableCurrentPage + 1) },
                createElement("i", { className: "icon-angle-right" }))))));
};
ColorfulTable.displayName = 'ColorfulTable';
export default ColorfulTable;
